import axios from "axios";


const API_URL = "/auth/admin/";

class adminAuthService {
    async login(login_details) {

        try {
            let res = await axios.post(API_URL + 'login.php', login_details);
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    logout() {
        localStorage.removeItem("auth_admin");
    }

    async register(admin) {
        let res = await axios.post(API_URL + "register.php", admin);
        if (res.data.token) {
            localStorage.setItem("sportips_auth_admin", JSON.stringify(res.data));
        }
    }



}

export default new adminAuthService();